import styled from "@emotion/styled";

import { ThemeMode } from "../../context/ThemeContext";

interface DeletePatientConfirmationWrapperProps {
  mode: ThemeMode;
}

export const DeletePatientConfirmationWrapper = styled.div<DeletePatientConfirmationWrapperProps>`
  box-sizing: border-box;
  margin: 0 auto;
  background: ${({ mode }) => (mode === "dark" ? "#2A2E39" : "#F0F0F0")};
  border-radius: 20px;
  padding: 30px 60px;
  color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
  overflow: hidden;
  text-align: center;
  position: relative;
  width: 100%;
  max-width: 500px;
  font-family: "Montserrat", sans-serif;

  .close-button {
    position: absolute;
    background-color: transparent;
    cursor: pointer;
    border: none;
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg path {
      fill: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};

      &:hover {
        fill: #badaff;
      }
    }
  }
`;
